<template>
  <div id="look-wrap">
    <h3>Look</h3>
    <p class="body look-item">
      <label for="bodyLook">Body </label>
      <input type="text" name="bodyLook" v-model="bodyLook" />
    </p>
    <p class="eyes look-item">
      <label for="bodyEyes">Eyes </label>
      <input type="text" name="bodyEyes" v-model="eyesLook" />
    </p>
    <p class="hair look-item">
      <label for="bodyHair">Hair </label>
      <input type="text" name="bodyHair" v-model="hairLook" />
    </p>
    <p class="clothes look-item">
      <label for="bodyClothes">Clothes </label>
      <input type="text" name="bodyClothes" v-model="clothesLook" />
    </p>
  </div>
</template>

<script>
export default {
  name: 'CharacterLook',
  computed: {
    bodyLook: {
      get() {
        return this.$store.state.character.look.body;
      },
      set(value) {
        this.$store.commit('updateCharacterLookBody', value);
      }
    },
    eyesLook: {
      get() {
        return this.$store.state.character.look.eyes;
      },
      set(value) {
        this.$store.commit('updateCharacterLookEyes', value);
      }
    },
    hairLook: {
      get() {
        return this.$store.state.character.look.hair;
      },
      set(value) {
        this.$store.commit('updateCharacterLookHair', value);
      }
    },
    clothesLook: {
      get() {
        return this.$store.state.character.look.clothes;
      },
      set(value) {
        this.$store.commit('updateCharacterLookClothes', value);
      }
    },
  }
}
</script>
<style lang="css">
.look-warp {
  display: flex;
  flex-direction: column;
}

input {
  padding: 0.3em;
  border: 1px solid #2c3e50;
  border-radius: 3px;
}

.look-item label {
  width:100px;
  margin-right: 0.3em;
}

p {
  margin-top: 0;
  margin-bottom: 0.5em;
  text-align: right;
}

h3 {
  margin-bottom: 0.7em;
}

</style>